import React from 'react';
import BaseComponent from './BaseComponent';
import Entry from './Entry';
import {connect} from 'react-redux';
import moment from 'moment';
import {List} from './UIList';

export class PureEntries extends BaseComponent {
    static get propTypes() {
        return {
            showDates: React.PropTypes.bool.isRequired,
        };
    }

    static get defaultProps() {
        return {
            showDates: false,
        };
    }

    render() {
        const {showDates, accompanist, band, event, events, entries, favourites} = this.props;

        let filteredEntries = entries.toList();
        let showBand, showEvent;

        if (event) {
            filteredEntries = filteredEntries.filter(e => e.event === event.id);
            showEvent = false;
        }

        if (band) {
            filteredEntries = filteredEntries.filter(e => e.band === band);
            showBand = false;
        }

        if (accompanist) {
            filteredEntries = filteredEntries.filter(e => e.accompanist === accompanist);
        }

        if (favourites) {
            filteredEntries = filteredEntries.filter(e => favourites.has(e.id));
        }

        if (filteredEntries.size === 0) {
            return <div className="entries" />;
        }

        let currentDate;
        let farFuture = moment().add(999, 'years');

        return <List className="entries">
            {filteredEntries.sortBy(e => e.start_time || farFuture).map(entry => {
                let dateHeading;
                if (showDates) {
                    let date = events.get(entry.event).start_time.clone().startOf('day');
                    if (!currentDate || !currentDate.isSame(date)) {
                        currentDate = date;
                        dateHeading = <div className="entries-date" key={date.unix()}>
                            {date.format('ddd Do MMM YYYY')}
                        </div>;
                    }
                }
                
                return [
                    dateHeading,
                    <Entry key={entry.id} entry={entry} showBand={showBand} showEvent={showEvent} />
                ];
            })}
        </List>;
    }
}

function mapStateToProps({app}) {
    return {
        events: app.get('events'),
        entries: app.get('entries'),
    };
}

export default connect(mapStateToProps)(PureEntries);



/** WEBPACK FOOTER **
 ** ./src/components/Entries.jsx
 **/